import Api from '../../../services/api'
import Notify from '../../../services/notify'

export default {
  watch: {
		birthdateDialog (val) {
			val && setTimeout(() => (this.$refs.BirthdatePicker.activePicker = 'YEAR'))
		},
	},
	data() {
		return {
			Api,
			debugMode: false,
			regions: [],
			provinces: [],
			cities: [],
			barangays: [],
			districts: [],
			
			birthProvinces: [],
			birthCities: [],

			loading: false,
			formValid: true,
			birthdateDialog: false,

			// existingUsername: null,
			// showPass: false,

			selectedDisability: 0,
			item: { },
	
			defaultItem: {
				lastname: null,
				middlename: '',
				firstname: null,
				extname: null,
				sex: 1,
				birthdate: null,
				civilStatus: null,
				region: 'REGION XI',
				province: null,
				city: null,
				barangay: null,
				district: null,
				street: null,

				birthRegion: 'REGION XI',
				birthProvince: null,
				birthCity: null,
				education: null,

				email: null,
				mobile: null,
				social: null,

				employmentStatus: null,
				employmentSchedule: '',
				disability: '',
			},
		}
	},
	created() {
		// debug fields
		if(this.debugMode) {
			this.defaultItem = {
				extname: null,
				firstname: 'REY',
				middlename: 'CANOVAS',
				lastname: 'SANCHEZ',
				sex: 0,
				birthdate: '1993-09-16',
				civilStatus: 'Single',
				region: 'REGION XI',
				province: 'DAVAO DEL NORTE',
				city: 'PANABO CITY',
				barangay: 'SALVACION',
				district: null,
				street: 'Purok 6',

				birthRegion: 'REGION XI',
				birthProvince: 'DAVAO DEL NORTE',
				birthCity: 'PANABO CITY',
				education: 'College Graduate or Higher',

				email: 'rcsanchez@tesda.gov.ph',
				mobile: '09305189181',
				social: null,

				employmentStatus: 'Employed',
				employmentSchedule: null,
				disability: '',
			};

			this.cities = ['PANABO CITY'];
			this.barangays = ['SALVACION'];
			this.birthCities = ['PANABO CITY'];
		}

		this.resetFields();
		this.refreshAllAddress();
		
		Api.address.getDistricts().then((districts) => {
			this.districts = districts;
		});

	},
	methods: {
		resetFields() {
			this.item = Object.assign({}, this.defaultItem);
		},
		
		register() {
			if(this.$refs.form.validate()) {
				if(!this.item.primaryCourseId || !this.item.courseTypeId) {
					Notify.toast('Select a course', 'error');
					return;
				}

				if(!this.item.identificationUploadId) {
					Notify.toast('ID Picture not found. Click upload after selecting the file', 'error');
					return;
				}

				if(!this.item.birthcertUploadId) {
					Notify.toast('Birth Certificate not found. Click upload after selecting the file', 'error');
					return;
				}

				this.loading = true;
				Api.register(this.item)
					.then(() => {
						Notify.success.registerCompleted();
						this.$emit('registration-created');
						// this.$router.push({ name: 'registerComplete' });
					})
					.catch(() => {
						this.loading = false;
						Notify.error.refresh();
					});
			} else {
				Notify.toast('Check your information above for errors', 'error');
			}
		},

		courseSelectedHandler(handlerObj) {
			this.item.courseTypeId = handlerObj.courseType.id;

			this.item.primaryCourseId = (handlerObj.courses[0])? handlerObj.courses[0].id : null;
			this.item.secondaryCourseId = (handlerObj.courses[1])? handlerObj.courses[1].id : null;
		},

		refreshAddress(code, destArrName, type) {
			let apiFunc = null;
			switch(type) {
				case 'province':
					apiFunc = Api.address.getProvinces;
				break;
				case 'city':
					apiFunc = Api.address.getCities;
				break;
				case 'barangay':
					apiFunc = Api.address.getBarangays;
				break;
			}

			apiFunc(code).then((response) => {
				this[destArrName] = response.data;
			});
		},
		
		refreshAllAddress() {
			Api.address.getRegions().then((response) => {
				this.regions = response.data;
	
				this.refreshAddress(
					this.getCode(this.item.region, this.regions, 'region'), 
					'provinces', 'province'
				);
				
				this.refreshAddress(
					this.getCode(this.item.birthRegion, this.regions, 'region'), 
					'birthProvinces', 'province'
				);
			});
		},

		getCode(selected, arr, type) {
			let desc = '';
			let code = '';

			switch(type) {
				case 'region':
					desc = 'regDesc';
					code = 'regCode';
				break;
				case 'province':
					desc = 'provDesc';
					code = 'provCode';
				break;
				case 'city':
					desc = 'citymunDesc';
					code = 'citymunCode';
				break;
			}

			for(let i=0; i<arr.length; i++) {
				if(selected == arr[i][desc]) {
					return arr[i][code];
				}
			}
			return null;
		},

		handleFileUpload(handleObj, propertyName) {
			this.item[propertyName] = handleObj.uploadId;
		},

		uppercase(item, property) {
			item[property] = item[property].toUpperCase();
		},

	}
}